import * as React from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const ImageWithTextOverlayNew = ({
  image,
  alt,
  preheading,
  heading,
  subheading,
  solidBackground,
  transparentBackground,
  textPosition,
  textAlignment,
  firstButtonLabel,
  firstButtonLink,
  highlightFirstButton,
  secondButtonLabel,
  secondButtonLink,
  highlightSecondButton,
}) => (
  <section className="page-banner">
    <GatsbyImage image={image} alt={alt} />
    <div
      className={`
        p-5
        ${textPosition === "left" ? "caption-left" : ""}
        ${textPosition === "right" ? "caption-right" : ""}
        ${textPosition === "center" ? "caption-center" : ""}
        ${textAlignment === "left" ? "has-text-left" : ""}
        ${textAlignment === "right" ? "has-text-right" : ""}
        ${textAlignment === "center" ? "has-text-centered" : ""}
        ${solidBackground && transparentBackground ? "is-transparent" : ""}
        ${
          solidBackground && !transparentBackground
            ? "has-background-white"
            : ""
        }
        ${!solidBackground && transparentBackground ? "is-transparent" : ""}
        ${!solidBackground && !transparentBackground ? "" : ""}
      `}
    >
      {preheading && <p className="is-size-5">{preheading}</p>}
      {heading && (
        <h1 className="is-size-1 is-size-2-mobile is-uppercase">{heading}</h1>
      )}
      {subheading && <p className="is-size-5">{subheading}</p>}
      {firstButtonLabel && (
        <div
          className={`buttons py-4 ${
            textAlignment === "center" ? "is-centered" : ""
          }`}
        >
          {firstButtonLink.includes("http") ? (
            <a
              href={firstButtonLink}
              title={firstButtonLabel}
              className={`button ${highlightFirstButton ? "is-danger" : ""}`}
            >
              {firstButtonLabel}
            </a>
          ) : (
            <Link
              to={firstButtonLink}
              title={firstButtonLabel}
              className={`button ${highlightFirstButton ? "is-danger" : ""}`}
            >
              {firstButtonLabel}
            </Link>
          )}
          {secondButtonLabel && (
            <>
              {secondButtonLink.includes("http") ? (
                <a
                  href={secondButtonLink}
                  title={secondButtonLabel}
                  className={`button ${
                    highlightSecondButton ? "is-danger" : ""
                  }`}
                >
                  {secondButtonLabel}
                </a>
              ) : (
                <Link
                  to={secondButtonLink}
                  title={secondButtonLabel}
                  className={`button ${
                    highlightSecondButton ? "is-danger" : ""
                  }`}
                >
                  {secondButtonLabel}
                </Link>
              )}
            </>
          )}
        </div>
      )}
    </div>
  </section>
)

export default ImageWithTextOverlayNew
